import React, {useState, useEffect} from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ImageUploader from "react-images-upload";
import configVars from "../../config";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import { setWithExpiry, getWithExpiry } from '../../common';
import { useSelector } from "react-redux";

const ProfilePic = () => {

    const [show, setShow] = useState(false);
    const [pictures, setPictures] = useState([]);
	const [imageFile, setImageFile] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [loading, setLoading] = useState(false);

    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const userData = useSelector((state) => state?.userdata?.allUserData);

    useEffect(() => {

        const savedProfilePic = getWithExpiry('profile_img_url');

        if ( savedProfilePic ) {
            setImageUrl( savedProfilePic );
        } else {
            if ( userData?.user_avatar) {
                setImageUrl(userData?.user_avatar);
            }
        }

    }, [userData]);

    const onDrop = picture => {

        setPictures(picture);
        
        if ( picture && picture[0] ) {
            const imageReader = new FileReader();

            imageReader.onload = (e) => {

                let i = new Image(); 

                i.onload = () => {
                    
                    if ( i.width > 400 ) {
                        setErrorMsg( 'Max bredd får inte vara mer än 400px' );
                    }

                    if ( i.height > 400 ) {
                        setErrorMsg( 'Maxhöjden får inte vara mer än 400px' );
                    }

                    if ( i.width <= 400 && i.height <= 400 ) {
                        setImageFile( e.target.result );
                    }

                };

                i.src = e.target.result;

            }

            imageReader.readAsDataURL(picture[0]);
        }
    };

    const clearUpload = () => {
        setImageFile('');
        setPictures([]);
        setErrorMsg('');
    }

    const saveProfilePic = async ( pictures ) => {

        if ( !pictures ) return;

        if ( ! cookies.sustainyou_user_jwt ) return;

        setLoading(true);

        const jwtDecoded = jwt_decode( cookies.sustainyou_user_jwt );

        let userRequestData = new FormData();
        userRequestData.append( 'img_data', pictures[0] );
        userRequestData.append( 'user_id', jwtDecoded.id );

        const fetchUrl = `${configVars.apiUrl}sustainchange/v1/uploadprofilepic/`;

        try{

            const response = await fetch(
                fetchUrl,
                {
                  method: "POST",
                  headers: {
                    Authorization: `Basic ${configVars.auth}`,
                  },
                  body: userRequestData
                }
            );
            
            const updateResponse = await response.json();
    
            if ( updateResponse ) {
                
                if ( updateResponse.success === true ) {
                    setImageUrl(updateResponse.data.profile_img_url);
                    setWithExpiry('profile_img_url', updateResponse.data.profile_img_url);
                    setShow(false);
                    window.location.reload(false);
                } else {
                    setErrorMsg('Något gick fel. Vänligen prova igen senare');
                }

                clearUpload();

            }

        } catch( error ) {
            console.log( error );
            return error;
        }

        setLoading(false);


    }

    return(
        <>
            

            <OverlayTrigger placement="bottom" overlay={
                <Tooltip >Ladda upp profilbild</Tooltip>
            }>
                <div className="user-profile-pic-inner position-absolute w-100" onClick={() => setShow(true)}>
                    <div className="user-profile-pic-content rounded-circle d-flex justify-content-center align-items-center bg-secondary text-white mx-auto position-relative">
                        <div className={`user-profile-pic-overlay position-absolute w-100 h-100 rounded-circle d-flex justify-content-center align-items-center ${imageUrl ? 'has-img' : ''}`}>
                        {imageUrl &&
                            <img src={imageUrl} alt="Profile" className="mw-100 w-100 rounded-circle" />
                        }
                            <div className="position-absolute top-0 right-0 w-100 h-100 d-flex justify-content-center align-items-center dark-overlay rounded-circle profile-pic-inner">
                                <i className="fa fa-camera" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </OverlayTrigger>

            <Offcanvas show={show} onHide={() => setShow(false)} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Ladda upp profilbild</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>

                    { errorMsg &&
                        <div className="mt-3">
                            <p className="text-sy-red">{errorMsg}</p>
                        </div>
                    }

                    <ImageUploader
                        withIcon={true}
                        onChange={onDrop}
                        imgExtension={[".jpg",".png", ".jpeg"]}
                        maxFileSize={2097152}
                        singleImage={true}
                        buttonText="Välj bild"
                        label="Max filstorlek: 2MB, 400x400px, accepterad: jpg, png, jpeg"
                    />

                { imageFile &&
                    <div>
                        <div className="profile-pic-preview mx-auto my-3 p-1 overflow-hidden" >
                            <img src={imageFile} alt="preview" className="mw-100" />
                        </div>
                        <div className="d-flex mt-5 justify-content-center">
                            <button type="button" className="btn btn-secondary px-4 btn-sm rounded-pill" style={{width: "120px"}} onClick={() => clearUpload()}>
                                <i className="fa fa-trash-o" aria-hidden="true"></i>
                                <span className="ms-2">Radera</span>
                            </button>
                            <button type="button" className="btn btn-secondary px-4 btn-sm rounded-pill ms-2" style={{width: "120px"}} onClick={() => saveProfilePic(pictures)}>
                                {loading &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }
                                {!loading &&
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                }
                                <span className="ms-2">Spara</span>
                            </button>
                        </div>
                    </div>
                }

                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default ProfilePic;